import React from 'react';
import MainLayout from 'modules/common/MainLayout';
import Page from 'modules/common/Page';
import TPGrid from 'components/TP-UI/TPGrid';
import { useTheme } from '@material-ui/core';
import PagePlaceholder from 'modules/common/PagePlaceholder';

const DashboardPage = () => {
  const { images } = useTheme();
  return (
    <Page docTitle="Dashboard">
      <MainLayout title="Dashboard">
        <TPGrid
          container
          direction="column"
          justifyContent="center"
          alignItems="center"
          spacing={1}>
          <TPGrid item>
            <PagePlaceholder
              image={images.common.waitingImg}
              message="Dashboard is not available in this hub"
            />
          </TPGrid>
        </TPGrid>
      </MainLayout>
    </Page>
  );
};

export default DashboardPage;
